export default function createExcerptMaintainingWords (sentence, maxLength, ellipsis = '... ') {
    const words = sentence.split(' ')
    const excerptWords = []

    let letters = 0
    for (let idx = 0, l = words.length; idx < l; idx++) {
        const word = words[idx]
        const wordLength = word.length

        if ((letters + wordLength) <= maxLength) {
            excerptWords.push(word)
            letters += wordLength + 1

        } else {
            break
        }
    }

    const lastWord = excerptWords[excerptWords.length - 1]
    if (lastWord && !lastWord.endsWith('.')) {
        excerptWords.push(ellipsis)
    }

    return excerptWords.join(' ')
}